import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpEvent} from "@angular/common/http";
import {Observable} from "rxjs";
import {baseUrl} from "../../../../constants/base-url";
import {SelectWbAccountData, UploadExcelParams} from "../types/upload-excel-modal.types";
import {emptyHttpHeaders} from "../../../../models/http-headers";

@Injectable({
  providedIn: 'root'
})
export class UploadExcelApiService {
  private http = inject(HttpClient);

  public getSelectDataWbAccounts(path: string): Observable<Array<SelectWbAccountData>> {
    return this.http.get<Array<SelectWbAccountData>>(`${baseUrl}/${path}/accounts`);
  }

  public uploadExcel(uploadExcelParams: UploadExcelParams): Observable<HttpEvent<void>> {
    const { path, file, account } = uploadExcelParams;

    return this.http.post<void>(`${baseUrl}/${path}/upload`, file, {
      reportProgress: true,
      observe: 'events',
      headers: emptyHttpHeaders,
      params: account ? { account: account } : {}
    });
  }
}
